import { createSlice } from "@reduxjs/toolkit"

export const orderSlice = createSlice({
  name: "order",
  initialState: {
    isInitiateOrderLoading: false,
    isVerifyOrderLoading: false,
  },
  reducers: {
    // initiate order
    setInitiateOrderLoading: (state) => {
      state.isInitiateOrderLoading = true
    },
    setInitiateOrderSuccess: (state) => {
      state.isInitiateOrderLoading = false
    },
    setInitiateOrderFailed: (state) => {
      state.isInitiateOrderLoading = false
    },
    // verify order
    setVerifyOrderLoading: (state) => {
      state.isVerifyOrderLoading = true
    },
    setVerifyOrderSuccess: (state) => {
      state.isVerifyOrderLoading = false
    },
    setVerifyOrderFailed: (state) => {
      state.isVerifyOrderLoading = false
    },
  },
})

export const {
  setInitiateOrderLoading,
  setInitiateOrderSuccess,
  setInitiateOrderFailed,
  setVerifyOrderLoading,
  setVerifyOrderSuccess,
  setVerifyOrderFailed,
} = orderSlice.actions
export default orderSlice.reducer
